import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		avatar: {
			// backgroundColor: theme.palette.primary.main,
		},
	} satisfies Record<string, CSSObject>);
};